import { createContext, useContext } from 'react';

import type {
  PlayerCameraControlsHandle,
  PlayerCameraInputMode,
} from '../types';

export interface PlayerCameraControlsContextValue {
  cameraControls: PlayerCameraControlsHandle | null;
  setCameraControls: (cameraControls: PlayerCameraControlsHandle | null) => void;
  inputMode: PlayerCameraInputMode;
  setInputMode: (inputMode: PlayerCameraInputMode) => void;
}

export const PlayerCameraControlsContext =
  createContext<PlayerCameraControlsContextValue | null>(null);

export function usePlayerCameraControlsContext() {
  const context = useContext(PlayerCameraControlsContext);
  if (!context) {
    throw new Error(
      'usePlayerCameraControlsContext must be used inside <Player.Root>.',
    );
  }
  return context;
}
